import { render } from "./IncomingCallDisplay.vue?vue&type=template&id=43a76b44&scoped=true"
import script from "./IncomingCallDisplay.vue?vue&type=script&lang=js"
export * from "./IncomingCallDisplay.vue?vue&type=script&lang=js"

import "./IncomingCallDisplay.vue?vue&type=style&index=0&id=43a76b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a76b44"]])

export default __exports__